import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import {TopAppBarRow as RmwcTopAppBarRow} from '@rmwc/top-app-bar'
import '@rmwc/top-app-bar/styles'

// eslint-disable-next-line no-unused-vars,react/prop-types
const FilteredRmwcTopAppBarRow = ({withBorder, dense, ...otherProps}) => <RmwcTopAppBarRow {...otherProps} />

const StyledRmwcTopAppBarRow = styled(FilteredRmwcTopAppBarRow)`
  ${(props) =>
    props.withBorder &&
    `
    &&& {
      border-bottom: 1px solid var(--mdc-theme-color-border);
    }
  `}
  ${(props) =>
    props.dense &&
    `
    &&& {
      height: 100%;
    }
  `}
`

const TopAppBarRow = ({children, withBorder = false, ...otherProps}) => (
  <StyledRmwcTopAppBarRow withBorder={withBorder} {...otherProps}>
    {children}
  </StyledRmwcTopAppBarRow>
)

TopAppBarRow.propTypes = {
  children: PropTypes.any,
  withBorder: PropTypes.bool
}

export {TopAppBarRow}
